<template>
  <div id="wordsMap" ref="wordsMap"></div>
</template>
<script>
import G6 from '@antv/g6'
import mapData1 from './cab01'
import mapData2 from './cab02'
import mapData3 from './cab03'
import mapData4 from './cab04'
import mapData5 from './cab05'
import mapData6 from './cab06'
import mapData7 from './cab07'
export default {
  props: {
    mapid: {
        type: Number,
        default: 1
    },
    // height: {
    //     type: Number,
    //     default: 1200
    // },
  },
  data() {
    return {
      width: 1000,
      height: 1300,
      graph: null,
      mapData: mapData1,
      BaseConfig: {
        nameFontSize: 14,
        childCountWidth: 22,
        countMarginLeft: 0,
        itemPadding: 24,
        nameMarginLeft: 12,
        rootPadding: 18,
      },
      // minWidth: 60,
      rootNodeStyle: {
        textColor: '#fff',
        rectColor: '#e32c2d'
        // rectColor: '#C5005E',
        // rectColor: '#003ABF'
        // rectColor: '#677859'
        // rectColor: '#AA2F8F',
      },
      relationNodesName: [],
      relationNodes: [],
      highlightEdgeColor: '#E95400',
      // 权重背景颜色
      bgWeight: {
          4: '#eeeeee',
          3: '#f4af23',
          2: '#ff8f1c',
          1: '#fc4c02',
          0: '#e32c2d',
      },
      // bgWeight: {
      //   4: '#eeeeee',
      //   3: '#FFD7E8',
      //   2: '#FFAACE',
      //   1: '#FF60A3',
      //   0: '#C5005E',
      // },
      // bgWeight: {
      //     4: '#eeeeee',
      //     3: '#B8CDFF',
      //     2: '#417BFF',
      //     1: '#004DFF',
      //     0: '#003ABF',
      // },
      // bgWeight: {
      //     4: '#eeeeee',
      //     3: '#D1E4C1',
      //     2: '#8CBE65',
      //     1: '#558F57',
      //     0: '#677859',
      // },
      //   bgWeight: {
      //     4: '#eeeeee',
      //     3: '#FED6FF',
      //     2: '#FFAEF7',
      //     1: '#FF44D6',
      //     0: '#AA2F8F',
      //   },
      // 权重字体颜色
      colorWeight: {
        0: '#333',
        1: '#fff',
      },
      rectAttrs: null,
      rectHeight: 0,
      // 点击选中的node节点
      selectedNode: null,
      // 子节点父节点对应map list
      relationMapList: [],
    }
  },
  methods: {
    // 节点样式
    registerNode() {
      G6.registerNode('treeNode', {
        draw: (cfg, group) => {
          const { name, selected, children, depth, isChild } = cfg
          // depth 树层级
          const rootNode = depth === 0
          const hasChildren = children && children.length !== 0
          const {
            childCountWidth,
            countMarginLeft,
            itemPadding,
            nameMarginLeft,
            rootPadding,
          } = this.BaseConfig

          let width = 0
          const height = 28
          const x = 0
          const y = -height / 2
          // 名称文本
          const text = group.addShape('text', {
            attrs: {
              text: name,
              x: x * 2,
              y,
              textAlign: 'left',
              textBaseline: 'top',
              fontFamily: 'PingFangSC-Regular',
            },
            cursor: 'pointer',
            name: 'name-text-shape',
          })
          const textWidth = text.getBBox().width
          width = textWidth + itemPadding + nameMarginLeft

          width = width < this.minWidth ? this.minWidth : width

          if (!rootNode && hasChildren) {
            width += countMarginLeft
            width += childCountWidth
          }

          const keyShapeAttrs = {
            x,
            y,
            width: width,
            height,
            radius: 4,
          }
          // keyShape根节点选中样式
          if (rootNode && selected) {
            keyShapeAttrs.fill = '#e8f7ff'
            keyShapeAttrs.stroke = '#e8f7ff'
          }
          const keyShape = group.addShape('rect', {
            attrs: keyShapeAttrs,
            name: 'root-key-shape-rect-shape',
          })

          // if (!rootNode) {
          // // 底部横线
          // group.addShape('path', {
          //     attrs: {
          //     path: [
          //         ['M', x - 1, 0],
          //         ['L', width, 0],
          //     ],
          //     stroke: '#AAB7C4',
          //     lineWidth: 1,
          //     },
          //     name: 'node-path-shape',
          // });
          // }

          const mainX = x - 10
          const mainY = -height + 15
          // console.log(name.length*30,'---177')
          if (rootNode) {
            let attrs = {
              x: mainX - 5,
              y: mainY - 50,
              width: name.length*50+30,
              height: height + 100,
              radius: 64,
              fill: this.rootNodeStyle.rectColor,
              cursor: 'pointer',
            }
            group.addShape('rect', {
              zIndex: 0,
              attrs,
              name: 'main-shape',
            })
            this.rectAttrs = attrs
          }

          // let nameColor = '#000';
          // if (selected) {
          //     nameColor = '#40A8FF';
          // }

          // 名称
          if (rootNode) {
            group.addShape('text', {
              zIndex: 0,
              attrs: {
                text: name,
                x: mainX + rootPadding,
                y: 1,
                textAlign: 'left',
                textBaseline: 'middle',
                fill: this.rootNodeStyle.textColor,
                fontSize: 48,
                fontFamily: 'PingFangSC-Regular',
                cursor: 'pointer',
              },
              name: 'root-text-shape',
            })
          } else {
            // const childCountHeight = 12;
            // const childCountX = width - childCountWidth;
            // const childCountY = -childCountHeight / 2;
            const finalWidth = depth === 1 ? width + 200 : width
            const finalHeight = depth === 1 ? height + 40 : height
            const finalRadius = depth === 1 ? 24 : 8
            const finalFontSize = depth === 1 ? 32 : 14
            const finalY = depth === 1 ? -height + 8 : -height + 15
            let attrs = {
              // x: mainX,
              // y: mainY,
              x: x - 4,
              y: finalY,
              width: finalWidth,
              height: finalHeight,
              radius: finalRadius,
              fill:
                isChild === false
                  ? this.bgWeight[depth - 1]
                  : this.bgWeight[depth],
              cursor: 'pointer',
            }
            group.addShape('rect', {
              zIndex: 0,
              attrs,
              name: 'not-root-text-shape',
            })
            this.rectAttrs = attrs
            group.addShape('text', {
              zIndex: 0,
              attrs: {
                text: name,
                x: selected ? mainX + 12 + nameMarginLeft : mainX + 20,
                y: y + 8,
                textAlign: 'start',
                textBaseline: 'top',
                fill: depth === 1 ? '#fff' : '#000',
                fontSize: finalFontSize,
                fontFamily: 'PingFangSC-Regular',
                cursor: 'pointer',
              },
              name: 'not-root-text-shape',
            })
          }
          return keyShape
        },
      })
    },
    // 边样式
    registerEdge() {
      let highlightEdgeColor = this.highlightEdgeColor
      console.log('edge')
      G6.registerEdge(
        'can-running',
        {
          afterDraw(cfg, group) {
            console.log('cfg', cfg)
            let targetNode = cfg.targetNode.getModel()
            if (
              Object.prototype.hasOwnProperty.call(targetNode, 'isChild') &&
              !targetNode.isChild &&
              targetNode.depth === 1
            ) {
              group.attr('opacity', 0)
            }
          },
          draw(cfg) {
            console.log('cfg', cfg)
          },
          setState(name, value, item) {
            const shape = item.get('keyShape')
            const length = shape.getTotalLength()
            if (name === 'running') {
              shape.animate(
                (ratio) => {
                  // the operations in each frame. Ratio ranges from 0 to 1 indicating the prograss of the animation. Returns the modified configurations
                  const startLen = ratio * length
                  const cfg = {
                    lineDash: [startLen, length - startLen],
                    stroke: highlightEdgeColor,
                  }
                  return cfg
                },
                {
                  repeat: false, // Whether executes the animation repeatly
                  duration: 2000, // the duration for executing once
                }
              )
            }
          },
        },
        'cubic-horizontal' // extend the built-in edge 'cubic'
      )
    },
    initGraph() {
      return new G6.TreeGraph({
        container: 'wordsMap',
        width: this.width,
        height: 300,
        modes: {
          default: [
            // 点击节点收起或展开
            // {
            //     type: 'collapse-expand',
            // },
            'drag-canvas',
            'zoom-canvas',
          ],
        },
        defaultNode: {
          type: 'treeNode',
          anchorPoints: [
            [0, 0.5],
            [1, 0.5],
          ],
        },
        defaultEdge: {
          type: 'cubic-horizontal',
          style: {
            stroke: '#000',
            lineWidth: 2,
          },
        },
        layout: {
          type: 'compactBox',
          direction: 'H',
          // getId: function getId(d) {
          //     return d.name;
          // },
          getHeight: function getHeight() {
            return 16
          },
          getWidth: (d) => {
            const labelWidth = G6.Util.getTextSize(
              d.name,
              this.BaseConfig.nameFontSize
            )[0]
            const width =
              this.BaseConfig.itemPadding +
              this.BaseConfig.nameMarginLeft +
              labelWidth +
              this.BaseConfig.rootPadding +
              this.BaseConfig.childCountWidth
            return width
            // return 40
          },
          getVGap: function getVGap() {
            return 10
          },
          getHGap: function getHGap() {
            return 180
          },
        },
      })
    },
    calcWeight(frequency) {
      // 权重计算
      let weight = 0
      if (frequency < 1) {
        weight = 0
      } else if (frequency >= 1 && frequency < 8) {
        weight = 1
      } else if (frequency >= 8 && frequency < 15) {
        weight = 2
      } else if (frequency >= 15 && frequency < 22) {
        weight = 3
      } else if (frequency >= 22 && frequency < 29) {
        weight = 4
      } else {
        weight = 5
      }
      return weight
      // return Math.floor(frequency/7) < 4 ? Math.floor(frequency/7) : 4;
    },
    initData(data) {
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        data.id = data.name
        if (!Object.prototype.hasOwnProperty.call(data, 'parent')) {
          data['parent'] = []
        }
        if (Object.prototype.hasOwnProperty.call(data, 'child')) {
          for (let item of data.children) {
            if (
              Object.prototype.hasOwnProperty.call(item, 'isChild') &&
              !item.isChild
            ) {
              item['parent'] = []
            } else {
              item['parent'] = data.parent.concat(data)
            }
            if (
              Object.prototype.hasOwnProperty.call(data, 'isChild') &&
              !data.isChild
            ) {
              item['isChild'] = false
            }
            this.initData(item)
          }
        }
      }
    },
    initWordsMap() {
      this.registerNode()
      this.registerEdge()
      this.graph = this.initGraph()
      this.graph.on('node:click', (evt) => {
        // 树图点击
        this.selectedNode = evt.item.getModel()
        this.$emit('setSelectedNode', this.selectedNode)
      })
      // 处理数据
      // this.initData(this.mapData)
      console.log('this.mapData', this.mapData)
      console.log('this.relationMapList', this.relationMapList)
      this.graph.data(this.mapData)
      this.graph.render()
      this.graph.fitView()
      //this.graph.zoom(0.3, { x: this.width / 2 + this.width / 4, y: this.height / 2 })
    },
  },
  mounted() {
    this.width = document.documentElement.clientWidth - 300;
    this.height = document.documentElement.clientHeight - 68
    this.height = document.documentElement.clientHeight
    this.initWordsMap()
  },
  watch: {
    mapid(nv) {
      console.log(nv,'----447')
        if(nv==1){
          this.mapData = mapData1
        }else if(nv==2){
           this.mapData = mapData2
        }else if(nv==3){
           this.mapData = mapData3
        }else if(nv==4){
           this.mapData = mapData4
        }else if(nv==5){
           this.mapData = mapData5
        }else if(nv==6){
           this.mapData = mapData6
        }else if(nv==7){
           this.mapData = mapData7
        }
        console.log(this.mapData,'---463')
        if(this.graph){
          this.graph.data(this.mapData)
        this.graph.render();
        this.graph.fitView()
        //this.graph.zoom(0.3, { x: this.width / 2 + this.width / 4, y: this.height / 2 })
        }else{
           this.initWordsMap()
        }
        
    }
  },
}
</script>
<style>
.wordsMap {
  overflow: hidden;
}
#wordsMap{
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/pages/fund/Map.vue